import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 border-t border-border-subtle">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-6 py-5">

        <p className="text-xs text-ink-tertiary">
          Legislative data via{" "}
          <a href="https://legiscan.com" target="_blank" rel="noopener noreferrer"
            className="font-medium transition-colors hover:text-ink-secondary focus:outline-none focus-visible:rounded focus-visible:ring-2 focus-visible:ring-primary">
            LegiScan
          </a>
          {" "}·{" "}
          <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer"
            className="font-medium transition-colors hover:text-ink-secondary focus:outline-none focus-visible:rounded focus-visible:ring-2 focus-visible:ring-primary">
            CC BY 4.0
          </a>
        </p>

        <p className="text-xs text-ink-disabled">
          DECAL Pilot · Not official legal advice · © {year}
        </p>

        <Link to="/about"
          className="text-xs text-ink-tertiary transition-colors hover:text-ink-secondary focus:outline-none focus-visible:rounded focus-visible:ring-2 focus-visible:ring-primary">
          About
        </Link>

      </div>
    </footer>
  );
}
